import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CloudSun03 = function CloudSun03(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      d: "M6.6 20C4.6118 20 3 18.3882 3 16.4c0-1.9882 1.6118-3.6 3.6-3.6.102 0 .203.0042.3029.0126C7.6406 10.7087 9.644 9.2 12 9.2c2.0023 0 3.7501 1.0898 4.6826 2.7087A4.0826 4.0826 0 0 1 16.95 11.9c2.2368 0 4.05 1.8132 4.05 4.05 0 2.2368-1.8132 4.05-4.05 4.05H6.6Z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M4.035 10.1A6.7812 6.7812 0 0 1 3.9 8.75C3.9 5.022 6.922 2 10.65 2c3.4228 0 6.2505 2.5476 6.6905 5.85M6.6 20C4.6118 20 3 18.3882 3 16.4c0-1.9882 1.6118-3.6 3.6-3.6.102 0 .203.0042.3029.0126C7.6406 10.7087 9.644 9.2 12 9.2c2.0023 0 3.7501 1.0898 4.6826 2.7087A4.0826 4.0826 0 0 1 16.95 11.9c2.2368 0 4.05 1.8132 4.05 4.05 0 2.2368-1.8132 4.05-4.05 4.05H6.6Z"
    })]
  }));
};
export default CloudSun03;